import {
  GetDynamicCardGridDocument,
  GetDynamicCardGridQuery,
  GetDynamicCardGridQueryVariables,
  Locale,
  Scalars,
} from 'generated/graphql';
import { client } from './client';

export async function getDynamicCardGrid(locale: string, id: string) {
  return client.query<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables>({
    query: GetDynamicCardGridDocument,
    variables: {
      locales: [locale as Locale],
      where: {
        id,
      },
    },
  });
}
